import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { OptionsEnum } from 'src/app/model/enums/OptionsEnum';
import { BaseOption } from 'src/app/model/BaseOption';
import { EnumConverterService } from 'src/app/services/EnumConverterService';
import { WaitingPeriod } from 'src/app/model/enums/WaitingPeriodEnum';
import { ComponentCommunicationService } from 'src/app/component-communication.service';
import { SessionGgService } from '../../../services/session-gg.service';
import { ValidationService } from '../../../services/ValidationService';
import { Constants } from '../../../constants';
import { CalculatorComponent } from '../../../calculator/calculator-component/calculator.component';

@Component({
  selector: 'app-personal-details-page-gg',
  templateUrl: './personal-details-page.component.html',
  styleUrls: ['./personal-details-page.component.css'],
})
export class PersonalDetailsPageGGComponent implements OnInit, OnDestroy {
  insured: FormGroup;
  form;
  OptionsEnum = OptionsEnum;
  yesNoList: BaseOption[] = [];
  riskPeriodList: BaseOption[] = [];
  showCriminalBlockError = false;
  thousandSeparator = Constants.THOUSAND_SEPARATOR;
  calculatorValues = null;

  @Output()
  destroyHandler = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private enumConverterService: EnumConverterService,
    private componentCommunication: ComponentCommunicationService,
    private sessionGgService: SessionGgService,
    private validationService: ValidationService,
    private dialogRef: MatDialog,
  ) {
    this.riskPeriodList = this.enumConverterService.toBaseList('WaitingPeriod', WaitingPeriod);
    this.yesNoList = this.enumConverterService.toBaseList('OptionsEnum', OptionsEnum);
  }

  ngOnInit(): void {
    this.initializeInsuredFormGroup();
    this.form.valueChanges.subscribe(() => {
      this.validationService.setPersonalDetailsValidators(this.form as FormGroup);
    });
    this.calculatorValues = this.sessionGgService.getCalculatorFormValues;
  }

  ngOnDestroy(): void {
    this.destroyHandler.emit(this.form.value);
  }

  get dateMaskFormat(): string {
    return this.componentCommunication.getDateFormat();
  }

  get IsCancelAOV(): boolean {
    return this.form.controls.insurerWillCancelInsurance.value === OptionsEnum.Yes;
  }

  get IsMeasures(): boolean {
    return this.form.controls.punitiveMeasures.value === OptionsEnum.Yes;
  }

  get IsAOVPresent(): boolean {
    return this.form.controls.insuranceSomewhereElse.value === OptionsEnum.Yes;
  }

  initializeInsuredFormGroup(): void {
    const formValues = this.sessionGgService.getPersonalDetailsFormValues;
    this.form = this.formBuilder.group(formValues);
    this.validationService.setPersonalDetailsValidators(this.form as FormGroup);
  }

  public toggleCalculator(): void {
    const dialogRef = this.dialogRef.open(CalculatorComponent, {
      height: '800px',
      width: '600px',
      data: this.calculatorValues,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((cbData) => {
      const {
        amount = 0,
        formValues = null,
      } = cbData || {};
      if (formValues) {
        this.calculatorValues = formValues;
        this.form.controls.monthlyExpenses.setValue(amount);
      }
    });
  }
}
